import type { Prototype } from "../prototype-types";

export const harshaYeddanapudyPrototypes: Prototype[] = [
  {
    id: "pay-as-you-go-issue-exploration",
    name: "Pay As You Go Issue Exploration",
    path: "/hy/pay-as-you-go-issue-exploration",
    description:
      "Faire Pay account page prototype with a side-sheet flow for changing payment preferences.",
    owner: "Harsha",
    createdAt: "2026-05-07",
    lastUpdated: "2026-05-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bdd7176880057434335c3815a32290742d3351e49a136920e2dcf0f99d5d3fe9.png",
  },
  {
    id: "faire-pay-invoice-integration-v1",
    name: "Faire Pay Invoice Integration V1",
    path: "/hy/faire-pay-invoice-integration-v1",
    description:
      "Starting point for exploring how Faire Pay context can integrate into invoice workflows.",
    owner: "Harsha",
    createdAt: "2026-04-28",
    lastUpdated: "2026-04-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/091be2bec836e732db87fac3e3402b7b6cf81775e03d508bdac608bc31d25303.png",
  },
  {
    id: "faire-pay-clarity-v2",
    name: "Faire Pay Clarity V2",
    path: "/hy/faire-pay-clarity-v2",
    description:
      "Updated invoice clarity explorations with improved Faire Pay tab and payment flows.",
    owner: "Harsha",
    createdAt: "2026-04-27",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e920fa87e271d409676c91beca81e41409d298db78290b61488d302e0402e4ab.png",
  },
  {
    id: "faire-pay-invoice-clarity",
    name: "Faire Pay Invoice Clarity",
    path: "/hy/faire-pay-invoice-clarity",
    description: "Testing ideas to solve retailer confusion on invoices page.",
    owner: "Harsha",
    createdAt: "2026-04-24",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/784fa01adfda0c63fbf5615283a8b386b629988f1d488a10c6d490ff473cbeed.png",
  },
];
